import { TimeType } from 'shared/components/date-picker/time-delay-picker/constants'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'
import { ContactWorkflowAction } from 'modules/contacts/contact-page/types/contact-workflow-step-action-interface'

export enum ContactWorkflowDelayTypeEnum {
  Date = 'date',
  Fixed = 'fixed',
}

export type ContactWorkflowDelay = (
  | ContactWorkflowDelayDateInterface
  | ContactWorkflowDelayFixedInterface
) & { id: number }

interface ContactWorkflowDelayDateInterface {
  type: ContactWorkflowDelayTypeEnum.Date
  date: string
}

interface ContactWorkflowDelayFixedInterface {
  type: ContactWorkflowDelayTypeEnum.Fixed
  duration: number
  unit: TimeType
}

export interface ContactWorkflowInterface {
  workflowStep: {
    id: number
    action?: ContactWorkflowAction
    workflow: {
      id: number
      name: string
    }
    delay?: ContactWorkflowDelay
  }
  isCompleted: boolean
  taskCreatedAt: string
  taskCompletedAt: string | undefined
}

export interface ContactWorkflowApiInterface
  extends DataWithPaginationInterface<ContactWorkflowInterface> {}
